// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__26Q2w","description":"PatientConsentPreview_description__35ozV"};